import axios from "../BASE_API";
import AuthHeader from "../AuthHeader";

export class DashboardAPI {
  getDashboardSummary: any = (days: number) => {
    return axios.get("/dashboard/summary", {
      params: { days: days },
      headers: AuthHeader(),
    });
  };
}
